import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Loading } from 'components'
import { useLoadOrderProposal, useUpdateOrder } from 'modules/orders/hooks'
import { Form } from 'modules/orders/components'
import { useOrderStore } from 'modules/orders/store'
import { getTimezonedIsoString, parseDateForDatePicker, uuId } from 'utils'
import { mapOrderItemFromApi } from 'modules/orders/components/Form/normalizeData'
import { useLayoutContext } from 'layout/layout.context'

const logicalResponse = (param: boolean) =>
  param ? { id: '1', name: 'SIM' } : { id: '0', name: 'NÃO' }

const generateDirtRoadQuizResponses = (dirtRoadQuiz: any) => {
  return {
    dirtRoadQuizQuest1: dirtRoadQuiz?.quest1,
    dirtRoadQuizQuest2: logicalResponse(!!dirtRoadQuiz?.quest2),
    dirtRoadQuizQuest3: logicalResponse(!!dirtRoadQuiz?.[0]?.quest3),
    dirtRoadQuizQuest4: logicalResponse(!!dirtRoadQuiz?.[0]?.quest4)
  }
}

export const EditOrderPage = () => {
  const { id } = useParams()
  const [defaultValues, setDefaultValues] = useState<any>()
  const addProductForm = useOrderStore.useAddProductForm()
  const registerSequence = useOrderStore.useRegisterSequence()
  const setForm = useOrderStore.useSetForm()
  const setCurrentStep = useOrderStore.useSetCurrentStep()
  const { setBreadcrumbs } = useLayoutContext()

  useEffect(() => {
    setCurrentStep('general')
  }, [id, setCurrentStep])

  useEffect(() => {
    setBreadcrumbs([
      { label: 'Início', to: '/home' },
      { label: 'Pedidos', to: '/orders' },
      { label: `Orçamento ${id}` }
    ])
    return () => setBreadcrumbs([])
  }, [id])

  const { data, isLoading: isProposalLoading } = useLoadOrderProposal(id)

  const { mutateAsync, isLoading } = useUpdateOrder()

  const handleSubmit = async (data: any) => {
    await mutateAsync({ ...data, orderId: id })
  }

  useEffect(() => {
    setDefaultValues({
      ...data,
      indicator: data?.indicator?.id ? data.indicator : null,
      saleChannel: data?.saleChannel?.id ? data.saleChannel : null,
      opportunity: data?.opportunityId ? { id: data?.opportunityId } : null,
      hasDirtRoadQuiz: Object.keys(data?.dirtRoadQuiz || {})?.length
        ? { id: '1', name: 'SIM' }
        : { id: '0', name: 'NAO' },
      // API retorna apenas o id; mapeamos para o objeto correto
      // na tela (General.tsx) usando a listagem de reservas
      cdPedidoReserva: data?.cdPedidoReserva || null,
      observation: data?.observation?.trim() || '',
      expeditionObs: data?.expeditionObs?.trim() || '',
      deliveryDate: parseDateForDatePicker(data?.deliveryDate),
      proposalValidity: data?.proposalValidity
        ? getTimezonedIsoString(data.proposalValidity)
        : null,
      requestedDate: parseDateForDatePicker(data?.requestedDate),
      ...generateDirtRoadQuizResponses(data?.dirtRoadQuiz)
    })

    setForm({
      orderItems: [],
      orderId: data?.proposalId,
      opportunity: data?.opportunityId ? { id: data?.opportunityId } : null,
      paymentResponsible: null
    })

    data?.products.forEach((item: any) => {
      const uuid = uuId()
      registerSequence({ id: uuid, itemSequence: item.sequence })
      addProductForm(
        mapOrderItemFromApi({
          ...item,
          commission: '0',
          configurationId: item.configurationId,
          configurationFormValues: item.configurations,
          defaultPrice: item.defaultPrice,
          defaultPrice4: item.defaultPrice4,
          currentPrice: item.currentPrice || item.defaultPrice,
          saleType: item.saleType || '12',
          id: item.product.id,
          pcpObservation: item.pcpObservation,
          product: item.product,
          salePrice: item.salePrice,
          uuid
        })
      )
    })
  }, [addProductForm, data, registerSequence, setForm, isProposalLoading])

  return (
    <>
      {isProposalLoading && (
        <div
          style={{
            height: '100%',
            width: 'calc(100% - 232px)',
            zIndex: 99,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'white'
          }}
        >
          <Loading />
        </div>
      )}
      <Form
        handleSubmit={handleSubmit}
        defaultValues={defaultValues}
        isSubmitting={isLoading}
        isEdit
      />
    </>
  )
}

export default EditOrderPage
